/**
 * Format a number into money that is locale aware
 *
 * @param {Number} number
 *
 * @return {String}
 */
export function format(number) {
    const isUk = document.body.className.indexOf("domain_uk") !== -1;

    const locale = isUk ? 'en-GB' : 'en-US';
    const currency = isUk ? 'GBP' : 'USD';

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        minimumFractionDigits: 0,
        currency,
    }).format(number);
}

export default format;


// WEBPACK FOOTER //
// ./resources/assets/js/money-format.js